import mondaySdk from "@monday/sdk";

import logger from "./logger";

export const openPlanSelection = async () => {
  try {
    await mondaySdk.execute("openPlanSelection", { isInPlanSelection: true });
  } catch (err) {
    logger.error("Error executing openPlanSelection:", err);
  }
};

export const openBillingSection = async () => {
  try {
    await mondaySdk.execute("openPlanSelection", { isInPlanSelection: false });
  } catch (err) {
    logger.error("Error executing openPlanSelection:", err);
  }
};
